export default "svg {\n  width: 20rem;\n}";